import React, { useState, useEffect } from "react";
import PaginationComponent from "../../../components/PaginationComponent";
import useInterventionHistory from "../../../utils/CustomHooks/useInterventionHistory";
import useScreenerHistory from "../../../utils/CustomHooks/useScreenerHistory";
import { sortArray } from "../../../utils/Functions/filter";
import QuestionTableItem from "../components/QuestionTableItem";

export default function ScreenerHistoryTable({ id = "" }) {
  const { screenerHistory, loading, getScreenerHistory } =
    useScreenerHistory("");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const pageCount = Math.ceil(screenerHistory.length / pageSize);

  useEffect(() => {
    if (id) getScreenerHistory(id);
  }, [id]);

  const handleClick = (event, index) => {
    event.preventDefault();
    setCurrentPage(index);
  };

  return (
    <>
      <table className="table table-borderless ">
        <thead>
          <tr className=" ">
            <td className="">Action</td>
            <td className="">Time </td>
            <td className="">By</td>
          </tr>
        </thead>
        <tbody>
          {screenerHistory.length > 0 ? (
            sortArray(screenerHistory)
              .slice(currentPage * pageSize, (currentPage + 1) * pageSize)
              .map((x, i) => <QuestionTableItem data={x} key={i} />)
          ) : (
            <tr>
              <td className="text-center font-weight-bold" colSpan="7">
                {loading ? "loading..." : "No Hisory Found..."}
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {screenerHistory.length > 0 && (
        <PaginationComponent
          handleClick={handleClick}
          currentPage={currentPage}
          pageCount={pageCount}
        />
      )}
    </>
  );
}
